import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { environment } from '@environments/environment';

export interface IGameType {
  id: number;
  name: string;
  text: string;
  thumb: string;
  application: string;
  tableid: string;
  gameType: string;
  limitid: string;
}

@Component({
  selector: 'casinoluckystreak-component',
  templateUrl: '../sharedTemplates/casinoluckystreak.component.html',
})
export class CasinoLuckyStreakComponent implements OnInit, AfterViewInit {
  gameTypes: Array<IGameType>;
  constructor(private _ApiService: ApiService, private _UiHelper: UiHelper, private _UserHelper: UserHelper, private _LocalizationService: LocalizationService) {}

  ngOnInit() {
    this.gameTypes = [
      {
        id: 8,
        name: 'BlackjackVIP2',
        text: 'Black jack VIP2',
        thumb: 'luckystreak/BlackjackVIP2.png',
        application: 'lobby',
        tableid: '54',
        gameType: 'Blackjack',
        limitid: '63ef6c519dd0f6ccbb979c02',
      },
      {
        id: 8,
        name: 'BlackjackVIP',
        text: 'Black jack VIP',
        thumb: 'luckystreak/BlackjackVIP.png',
        application: 'lobby',
        tableid: '7',
        gameType: 'Blackjack',
        limitid: '63970cf7f6af56ae2828eff2',
      },
      //Blackjack7,Blackjack6,Blackjack16,Roulette3,Roulette1,AutoRoulette2,console hatalı AutoRoulette4,Oracle360,PortomasoCasinoRoulette2
      {
        id: 8,
        name: 'Blackjack7',
        text: 'Black jack 7',
        thumb: 'luckystreak/Blackjack7.png',
        application: 'lobby',
        tableid: '36',
        gameType: 'Blackjack',
        limitid: '621ccba0b6a4e312ac3a720a',
      },
      {
        id: 8,
        name: 'Blackjack6',
        text: 'Black jack 6',
        thumb: 'luckystreak/Blackjack6.png',
        application: 'lobby',
        tableid: '12',
        gameType: 'Blackjack',
        limitid: '621ccba0b6a4e312ac3a720a',
      },
      {
        id: 8,
        name: 'Blackjack16',
        text: 'Black jack 16',
        thumb: 'luckystreak/Blackjack16.png',
        application: 'lobby',
        tableid: '27',
        gameType: 'Blackjack',
        limitid: '621ccba0b6a4e312ac3a720a',
      },
      {
        id: 8,
        name: 'Roulette3',
        text: 'Roulette 3',
        thumb: 'luckystreak/Roulette3.png',
        application: 'lobby',
        tableid: '52',
        gameType: 'Roulette',
        limitid: '63970d2df6af56ae282bb3f3',
      },
      // {
      //   id: 8,
      //   name: 'Roulette2',
      //   text: 'Roulette 2',
      //   thumb: 'luckystreak/Roulette2.png',
      //   application: 'lobby',
      //   tableid: '3',
      //   gameType: 'Roulette',
      //   limitid: '63970d2df6af56ae282bb3f3',
      // },
      {
        id: 8,
        name: 'Baccarat4',
        text: 'Baccarat 4',
        thumb: 'luckystreak/Baccarat4.png',
        application: 'lobby',
        tableid: '2',
        gameType: 'Baccarat',
        limitid: '63a414745bf95ca5ba1ec09e',
      },
      {
        id: 8,
        name: 'Baccarat2',
        text: 'Baccarat 2',
        thumb: 'luckystreak/Baccarat2.png',
        application: 'lobby',
        tableid: '13',
        gameType: 'Baccarat',
        limitid: '63a414745bf95ca5ba1ec09e',
      },
      {
        id: 8,
        name: 'Roulette1',
        text: 'Roulette 1',
        thumb: 'luckystreak/Roulette1.png',
        application: 'lobby',
        tableid: '3',
        gameType: 'Roulette',
        limitid: '63970d2df6af56ae282bb3f3',
      },

      {
        id: 8,
        name: 'AutoRoulette2',
        text: 'AutoRoulette 2',
        thumb: 'luckystreak/AutoRoulette2.png',
        application: 'lobby',
        tableid: '53',
        gameType: 'AutoRoulette',
        limitid: '63970d3af6af56ae282c73a2',
      },
      {
        id: 8,
        name: 'AutoRoulette4',
        text: 'AutoRoulette 4',
        thumb: 'luckystreak/AutoRoulette4.png',
        application: 'lobby',
        tableid: '11',
        gameType: 'AutoRoulette',
        limitid: '63970d3af6af56ae282c73a2',
      },
      {
        id: 8,
        name: 'PortomasoCasinoRoulette2',
        text: 'Portomaso Casino Roulette 2',
        thumb: 'luckystreak/PortomasoCasinoRoulette2.png',
        application: 'lobby',
        tableid: '29',
        gameType: 'ExternalRoulette',
        limitid: '63970d65f6af56ae282ebd87',
      },
      {
        id: 8,
        name: 'Oracle360',
        text: 'Oracle 360',
        thumb: 'luckystreak/Oracle360.png',
        application: 'lobby',
        tableid: '128',
        gameType: 'ExternalRoulette',
        limitid: '63970d65f6af56ae282ebd87',
      },
      // {
      //   id: 8,
      //   name: 'Blackjack9',
      //   text: 'Black jack 9',
      //   thumb: 'luckystreak/Blackjack9.png',
      //   application: 'lobby',
      //   tableid: '14',
      //   gameType: 'Blackjack',
      //   limitid: '621ccba0b6a4e312ac3a720a',
      // },
      // {
      //   id: 8,
      //   name: 'Blackjack10',
      //   text: 'Black jack 10',
      //   thumb: 'luckystreak/Blackjack10.png',
      //   application: 'lobby',
      //   tableid: '15',
      //   gameType: 'Blackjack',
      //   limitid: '621ccba0b6a4e312ac3a720a',
      // },
      // {
      //   id: 8,
      //   name: 'Blackjack11',
      //   text: 'Black jack 11',
      //   thumb: 'luckystreak/Blackjack11.png',
      //   application: 'lobby',
      //   tableid: '16',
      //   gameType: 'Blackjack',
      //   limitid: '621ccba0b6a4e312ac3a720a',
      // },
      // {
      //   id: 8,
      //   name: 'Blackjack12',
      //   text: 'Black jack 12',
      //   thumb: 'luckystreak/Blackjack12.png',
      //   application: 'lobby',
      //   tableid: '17',
      //   gameType: 'Blackjack',
      //   limitid: '621ccba0b6a4e312ac3a720a',
      // },
      // {
      //   id: 8,
      //   name: 'Blackjack13',
      //   text: 'Black jack 13',
      //   thumb: 'luckystreak/Blackjack13.png',
      //   application: 'lobby',
      //   tableid: '18',
      //   gameType: 'Blackjack',
      //   limitid: '621ccba0b6a4e312ac3a720a',
      // },
      // {
      //   id: 8,
      //   name: 'Blackjack14',
      //   text: 'Black jack 14',
      //   thumb: 'luckystreak/Blackjack14.png',
      //   application: 'lobby',
      //   tableid: '21',
      //   gameType: 'Blackjack',
      //   limitid: '621ccba0b6a4e312ac3a720a',
      // },
      // {
      //   id: 8,
      //   name: 'Blackjack15',
      //   text: 'Black jack 15',
      //   thumb: 'luckystreak/Blackjack15.png',
      //   application: 'lobby',
      //   tableid: '22',
      //   gameType: 'Blackjack',
      //   limitid: '621ccba0b6a4e312ac3a720a',
      // },
      // // {
      // //   id: 8,
      // //   name: 'Blackjack17',
      // //   text: 'Black jack 17',
      // //   thumb: 'luckystreak/Blackjack17.png',
      // //   application: 'lobby',
      // //   tableid: '38',
      // //   gameType: 'Blackjack',
      // //   limitid: '621ccba0b6a4e312ac3a720a',
      // // },
      // // {
      // //   id: 8,
      // //   name: 'Blackjack18',
      // //   text: 'Black jack 18',
      // //   thumb: 'luckystreak/Blackjack18.png',
      // //   application: 'lobby',
      // //   tableid: '39',
      // //   gameType: 'Blackjack',
      // //   limitid: '621ccba0b6a4e312ac3a720a',
      // // },
      // {
      //   id: 8,
      //   name: 'Blackjack20',
      //   text: 'Black jack 20',
      //   thumb: 'luckystreak/Blackjack20.png',
      //   application: 'lobby',
      //   tableid: '41',
      //   gameType: 'Blackjack',
      //   limitid: '621ccba0b6a4e312ac3a720a',
      // },
      // // {
      // //   id: 8,
      // //   name: 'BlackjackUy1',
      // //   text: 'Black jack uy1',
      // //   thumb: 'luckystreak/BlackjackUy1.png',
      // //   application: 'lobby',
      // //   tableid: '42',
      // //   gameType: 'Blackjack',
      // //   limitid: '621ccba0b6a4e312ac3a720a',
      // // },
      // // {
      // //   id: 8,
      // //   name: 'BlackjackUy2',
      // //   text: 'Black jack uy2',
      // //   thumb: 'luckystreak/BlackjackUy2.png',
      // //   application: 'lobby',
      // //   tableid: '50',
      // //   gameType: 'Blackjack',
      // //   limitid: '621ccba0b6a4e312ac3a720a',
      // // },
      // {
      //   id: 8,
      //   name: 'BlackjackUy3',
      //   text: 'Black jack uy3',
      //   thumb: 'luckystreak/BlackjackUy3.png',
      //   application: 'lobby',
      //   tableid: '51',
      //   gameType: 'Blackjack',
      //   limitid: '621ccba0b6a4e312ac3a720a',
      // },
      // // {
      // //   id: 8,
      // //   name: 'BlackjackUy5',
      // //   text: 'Black jack uy5',
      // //   thumb: 'luckystreak/BlackjackUy5.png',
      // //   application: 'lobby',
      // //   tableid: '55',
      // //   gameType: 'Blackjack',
      // //   limitid: '621ccba0b6a4e312ac3a720a',
      // // },

      // {
      //   id: 8,
      //   name: 'BaccaratUy4',
      //   text: 'Baccarat uy5',
      //   thumb: 'luckystreak/BaccaratUy4.png',
      //   application: 'lobby',
      //   tableid: '48',
      //   gameType: 'Baccarat',
      //   limitid: '63a414745bf95ca5ba1ec09e',
      // },
    ];
  }

  openGame(item) {
    if (!this._UserHelper.isSignedIn) {
      const translator = new TranslatePipe(this._LocalizationService);
      const t_message = translator.transform('errorcode5', null);
      this._UiHelper.errorSnackBar(t_message, '');
      return;
    }

    this._ApiService.CasinoLuckyStreakLaunch(item.id, item.application, item.tableid, item.gameType, item.limitid).then(x => {
      if (x) {
        window.location.href = x;
      }
    });
  }

  ngAfterViewInit() {
    if (this._UiHelper.leftMenu) {
      this._UiHelper.setLeftMenu();
    }
    this._UiHelper.setNavbarTitle('Casino', true);
  }
}
